<nz-spin [nzSpinning]="loading$ | async">
  <div class="records">
    <div class="content-wrapper">
      <nz-collapse [nzBordered]="false" [nzExpandIconPosition]="'end'">
        <nz-collapse-panel
          *ngFor="let panel of panels; let i = index"
          [nzHeader]="panel.name"
          [(nzActive)]="panel.active"
          (nzActiveChange)="onPanelChange(i, $event)"
          [nzExtra]="extraTpl">
          <p class="collapse-content" *ngFor="let obj of panel.content">
            <button
              nz-button
              type="button"
              nzType="text"
              class="primary-text-btn"
              (click)="downloadFile(obj)">
              {{ obj.name }}
            </button>
          </p>
          <ng-template #extraTpl let-panel>
            <button
              type="button"
              nz-button
              nzType="default"
              aria-label="Settings"
              class="collapse-btn">
              <svg-icon
                [src]="
                  this.selectedPanel[i]
                    ? '/assets/icon/icon-minus.svg'
                    : '/assets/icon/icon-plus.svg'
                "
                class="icon s-12"
                aria-label="Icon"></svg-icon>
            </button>
          </ng-template>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
  </div>
</nz-spin>

<!-- Button in the "extra" section of the panel -->
